import script from "./WhatsNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./WhatsNew.vue?vue&type=script&lang=ts&setup=true"

import "./WhatsNew.vue?vue&type=style&index=0&id=03cdf3a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03cdf3a4"]])

export default __exports__